import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { useQueryClient } from "@tanstack/react-query";
import { AppShell } from "../components/app-shell";
import { apiFetch } from "../lib/api";
import { fetchUser } from "../lib/auth";
import { logout as msalLogout } from "../lib/msal";

/**
 * Everything below this route requires a signed-in user. The role split lives in
 * the nested `_admin` / `_contractor` layouts.
 */
export const Route = createFileRoute("/_authed")({
  beforeLoad: async ({ context, location }) => {
    const user = await fetchUser(context.queryClient);
    if (!user) {
      throw redirect({ to: "/login", search: { redirect: location.href } });
    }
    // Downstream routes read `context.user` instead of re-fetching.
    return { user };
  },
  component: AuthedLayout,
});

function AuthedLayout() {
  const { user } = Route.useRouteContext();
  const queryClient = useQueryClient();

  async function signOut() {
    // Best-effort server ping (there is no server session), then clear local
    // state and hand off to MSAL, which clears its token cache and redirects to
    // Entra's logout — that redirect is what actually ends the sign-in (S1.2).
    await apiFetch("POST /api/auth/logout").catch(() => undefined);
    queryClient.clear();
    await msalLogout();
  }

  return (
    <AppShell user={user} onSignOut={() => void signOut()}>
      <Outlet />
    </AppShell>
  );
}
